module.exports = __webpack_public_path__ + "img/img2.131d4e6d.png";